import { APP_CONFIG } from "../constants/global-variables.js";

export async function winningReport(game_id) {
  const url = `${APP_CONFIG.URL.apiBasePath}backoffice/winningreport`;

  try {
    const res = await axios.post(
      url,
      {
        game: game_id,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data.data;
  } catch (e) {}
  return null;
}

export async function marketReport(type_id, date) {
  const url = `${APP_CONFIG.URL.apiBasePath}backoffice/betsumonmarketoptions`;

  try {
    const res = await axios.post(
      url,
      {
        type: type_id,
        date: date,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data.data;
  } catch (e) {}
  return null;
}

export async function marketDateReport(type_id, date) {
  const url = `${APP_CONFIG.URL.apiBasePath}backoffice/betsumonmarkets`;

  try {
    const res = await axios.post(
      url,
      {
        type: type_id,
        date: date,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data.data;
  } catch (e) {}
  return null;
}

export async function efficientReport(start_date, end_date) {
  const url = `${APP_CONFIG.URL.apiBasePath}backoffice/efficiency`;

  try {
    const res = await axios.post(
      url,
      {
        start_date,
        end_date,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data.data.data;
  } catch (e) {}
  return null;
}

export async function userReport() {
  const url = `${APP_CONFIG.URL.apiBasePath}backoffice/users`;

  try {
    const res = await axios.post(url, null, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        "Content-Type": "application/json",
      },
    });

    return res.data;
  } catch (e) {}
  return null;
}

export async function financeReportAdmin(
  start_date,
  end_date,
  user,
  closed_bets_only,
  live_or_prematch
) {
  const url = `${APP_CONFIG.URL.apiBasePath}backoffice/accountbalanceadmin`;

  try {
    const res = await axios.post(
      url,
      {
        user: user ? user : 0,
        start_date,
        end_date,
        closed_bets_only: `${closed_bets_only}`,
        live_or_prematch,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data.data;
  } catch (e) {}
  return null;
}
export async function financeReportUser(
  start_date,
  end_date,
  user,
  closed_bets_only,
  live_or_prematch
) {
  const url = `${APP_CONFIG.URL.apiBasePath}backoffice/accountbalanceuser`;

  try {
    const res = await axios.post(
      url,
      {
        user,
        start_date,
        end_date,
        closed_bets_only: `${closed_bets_only}`,
        live_or_prematch,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data.data;
  } catch (e) {}
  return null;
}
export async function superManagersList() {
  const url = `${APP_CONFIG.URL.apiBasePath}backoffice/supermanagers`;

  try {
    const res = await axios.post(url, null, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        "Content-Type": "application/json",
      },
    });

    return res.data;
  } catch (e) {}
  return null;
}

export async function userhierarchy(user) {
  const url = `${APP_CONFIG.URL.apiBasePath}backoffice/userhierarchy`;

  try {
    const res = await axios.post(
      url,
      {
        user,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data.data;
  } catch (e) {}
  return null;
}
